// // import React, { useState, useEffect } from 'react';
// // import { Input, Selectbox } from '../../css/Shared';
// // import { useJobContext } from '../../context/JobContext';
// // import api from '../../components/Api';
// // import { useAppContext } from '../../context/AppContext';
// // import Papa from 'papaparse';
// // import { toast } from 'react-toastify';

// // const STATES = [
// //   'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA',
// //   'HI','ID','IL','IN','IA','KS','KY','LA','ME','MD',
// //   'MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
// //   'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC',
// //   'SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'
// // ];

// // const DataCleanupTab = ({ goToNextTab, goToPrevTab }) => {
// //   const { formData, setFormData, finalCSV, setFinalCSV } = useJobContext();
// //   const { authState } = useAppContext();

// //   const [suppressionLists, setSuppressionLists] = useState([]);
// //   const [seedLists, setSeedLists] = useState([]);
// //   const [loadingLists, setLoadingLists] = useState(true);

// //   // Fetch suppression and seed lists
// //   useEffect(() => {
// //     const fetchLists = async () => {
// //       try {
// //         setLoadingLists(true);
// //         const [suppressRes, seedsRes] = await Promise.all([
// //           api.post('/permits/suppress/all', { id: authState.user.company._id }),
// //           api.post('/permits/seeds/all', { id: authState.user.company._id })
// //         ]);
// //         setSuppressionLists(suppressRes.data || []);
// //         setSeedLists(seedsRes.data || []);
// //       } catch (err) {
// //         console.error('Failed to load lists:', err);
// //       } finally {
// //         setLoadingLists(false);
// //       }
// //     };
// //     fetchLists();
// //   }, [authState.user.company._id]);

// //   // Helper to toggle restricted states
// //   const toggleState = (abbr) => {
// //     const states = formData.restrictStates || [];
// //     setFormData({
// //       ...formData,
// //       restrictStates: states.includes(abbr)
// //         ? states.filter(s => s !== abbr)
// //         : [...states, abbr]
// //     });
// //   };

// //   const handlePrev = () => goToPrevTab();

// //   // Add seeds and suppression to CSV
// //   const handleNext = async () => {
// //     try {
// //       if (
// //         (formData.seedMode === 'existing' && formData.selectedSeedListIds?.length) ||
// //         (formData.dnmMode === 'existing' && formData.selectedSuppressionListIds?.length)
// //       ) {
// //         const csvText = await finalCSV.text();
// //         const parsed = Papa.parse(csvText, { header: false });
// //         const rows = parsed.data;

// //         if (!rows.length) { goToNextTab(); return; }

// //         const headers = rows[0];

// //         // Add seed & suppress columns if missing
// //         if (!headers.includes('seed')) headers.push('seed');
// //         if (!headers.includes('suppress')) headers.push('suppress');

// //         const seedIndex = headers.indexOf('seed');
// //         const suppressIndex = headers.indexOf('suppress');

// //         // Ensure all existing rows have seed & suppress columns
// //         for (let i = 1; i < rows.length; i++) {
// //           rows[i][seedIndex] = rows[i][seedIndex] || '';
// //           rows[i][suppressIndex] = rows[i][suppressIndex] || '';
// //         }

// //         // ---------- Seeds ----------
// //         const seedsToAdd = [];
// //         formData.selectedSeedListIds?.forEach(id => {
// //           const list = seedLists.find(l => l._id === id);
// //           list?.seeds?.forEach(seed => {
// //             const newRow = new Array(headers.length).fill('');
// //             const map = {
// //               prefix: seed.prefix,
// //               firstName: seed.firstName,
// //               lastName: seed.lastName,
// //               middleName: seed.middleName,
// //               company: seed.company,
// //               suffix: seed.suffix,
// //               address1: seed.address1,
// //               address2: seed.address2,
// //               address3: seed.address3,
// //               city: seed.city,
// //               state: seed.state,
// //               zip: seed.zip
// //             };
// //             Object.keys(map).forEach(key => {
// //               const idx = headers.indexOf(key);
// //               if (idx !== -1) newRow[idx] = map[key] || '';
// //             });
// //             newRow[seedIndex] = 'Y';
// //             seedsToAdd.push(newRow);
// //           });
// //         });

// //         // ---------- Suppression ----------
// //         const suppressionToAdd = [];
// //         formData.selectedSuppressionListIds?.forEach(id => {
// //           const list = suppressionLists.find(l => l._id === id);
// //           list?.seeds?.forEach(s => {
// //             const newRow = new Array(headers.length).fill('');
// //             const map = {
// //               prefix: s.prefix,
// //               firstName: s.firstName,
// //               lastName: s.lastName,
// //               middleName: s.middleName,
// //               company: s.company,
// //               suffix: s.suffix,
// //               address1: s.address1,
// //               address2: s.address2,
// //               address3: s.address3,
// //               city: s.city,
// //               state: s.state,
// //               zip: s.zip
// //             };
// //             Object.keys(map).forEach(key => {
// //               const idx = headers.indexOf(key);
// //               if (idx !== -1) newRow[idx] = map[key] || '';
// //             });
// //             newRow[suppressIndex] = 'Y';
// //             suppressionToAdd.push(newRow);
// //           });
// //         });

// //         // Insert seeds & suppression randomly into CSV
// //         const dataRows = rows.slice(1);
// //         seedsToAdd.forEach(row => {
// //           const randomIndex = Math.floor(Math.random() * (dataRows.length + 1));
// //           dataRows.splice(randomIndex, 0, row);
// //         });
// //         suppressionToAdd.forEach(row => {
// //           const randomIndex = Math.floor(Math.random() * (dataRows.length + 1));
// //           dataRows.splice(randomIndex, 0, row);
// //         });

// //         // Rebuild CSV
// //         rows.length = 0;
// //         rows.push(headers);
// //         dataRows.forEach(r => rows.push(r));

// //         const newCSV = Papa.unparse(rows);
// //         setFinalCSV(new Blob([newCSV], { type: 'text/csv' }));
// //         toast.success('Seed and suppression addresses added to CSV!');
// //       }
// //     } catch (err) {
// //       console.error('Seed/suppression append failed:', err);
// //       toast.error('Failed to append seed/suppression lists');
// //     }

// //     goToNextTab();
// //   };

// //   return (
// //     <div className="bg-white border rounded-lg p-6 space-y-6 text-sm">
// //       <h3 className="text-sm font-semibold text-gray-700">Data (List) Cleanup</h3>

// //       {/* ================= NCOA / CURRENT RESIDENT ================= */}
// //       <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
// //         <div>
// //           <label className="text-xs font-medium text-gray-600 mb-1 block">Are we NCOA’ing the List?</label>
// //           <Selectbox
// //             value={formData.ncoa === false ? 'no' : 'yes'}
// //             onChange={e =>
// //               setFormData({
// //                 ...formData,
// //                 ncoa: e.target.value === 'yes',
// //                 alreadyNcoa: null,
// //                 currentResident: null,
// //                 ncoaDate: ''
// //               })
// //             }
// //           >
// //             <option value="yes">Yes</option>
// //             <option value="no">No</option>
// //           </Selectbox>
// //         </div>

// //         {formData.ncoa === false && (
// //           <div>
// //             <label className="text-xs font-medium text-gray-600 mb-1 block">Already been NCOA’d?</label>
// //             <Selectbox
// //               value={formData.alreadyNcoa === null ? '' : formData.alreadyNcoa ? 'yes' : 'no'}
// //               onChange={e =>
// //                 setFormData({
// //                   ...formData,
// //                   alreadyNcoa: e.target.value === 'yes',
// //                   currentResident: null,
// //                   ncoaDate: ''
// //                 })
// //               }
// //             >
// //               <option value="">Select</option>
// //               <option value="yes">Yes</option>
// //               <option value="no">No</option>
// //             </Selectbox>
// //           </div>
// //         )}

// //         {formData.ncoa === false && formData.alreadyNcoa === true && (
// //           <div>
// //             <label className="text-xs font-medium text-gray-600 mb-1 block">Date of NCOA</label>
// //             <Input
// //               type="date"
// //               value={formData.ncoaDate || ''}
// //               onChange={e =>
// //                 setFormData({ ...formData, ncoaDate: e.target.value })
// //               }
// //             />
// //           </div>
// //         )}

// //         {formData.ncoa === false && formData.alreadyNcoa === false && (
// //           <div>
// //             <label className="text-xs font-medium text-gray-600 mb-1 block">Current Resident Mailing?</label>
// //             <Selectbox
// //               value={formData.currentResident === null ? '' : formData.currentResident ? 'yes' : 'no'}
// //               onChange={e =>
// //                 setFormData({ ...formData, currentResident: e.target.value === 'yes' })
// //               }
// //             >
// //               <option value="">Select</option>
// //               <option value="yes">Yes</option>
// //               <option value="no">No</option>
// //             </Selectbox>
// //           </div>
// //         )}
// //       </div>

// //       {/* ============ ADDRESS FILTERING ============ */}
// //       <div className="border-t pt-4 space-y-4">
// //         <div className="font-medium text-xs text-gray-700">Address Filtering</div>

// //         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
// //           <div>
// //             <label className="text-xs text-gray-600 block mb-1">Radius Zipcode</label>
// //             <Input
// //               value={formData.radiusZip || ''}
// //               onChange={e => setFormData({ ...formData, radiusZip: e.target.value })}
// //             />
// //           </div>
// //           <div>
// //             <label className="text-xs text-gray-600 block mb-1">Radius (Miles)</label>
// //             <Input
// //               value={formData.radiusMiles || '0.0'}
// //               onChange={e => setFormData({ ...formData, radiusMiles: e.target.value })}
// //             />
// //           </div>
// //         </div>

// //         {/* Restrict States */}
// //         <details className="mt-4">
// //           <summary className="cursor-pointer text-xs font-medium text-gray-700">Restrict to States</summary>
// //           <div className="flex flex-wrap gap-2 mt-3">
// //             {STATES.map(s => (
// //               <button
// //                 key={s}
// //                 type="button"
// //                 onClick={() => toggleState(s)}
// //                 className={`px-2 py-1 border rounded text-xs ${
// //                   (formData.restrictStates || []).includes(s)
// //                     ? 'bg-blue-600 text-white'
// //                     : 'bg-gray-50'
// //                 }`}
// //               >
// //                 {s}
// //               </button>
// //             ))}
// //           </div>
// //         </details>

// //         {/* Checkboxes */}
// //         <div className="flex flex-wrap gap-6 items-center text-xs pt-2">
// //           <label className="flex items-center gap-2 text-xs">
// //             <input
// //               type="checkbox"
// //               checked={!!formData.removeMoved}
// //               onChange={e => setFormData({ ...formData, removeMoved: e.target.checked })}
// //             />
// //             Remove all records that moved
// //           </label>

// //           <label className="flex items-center gap-2 text-xs">
// //             <input
// //               type="checkbox"
// //               checked={!!formData.dedup}
// //               onChange={e => setFormData({ ...formData, dedup: e.target.checked })}
// //             />
// //             Remove duplicate records
// //           </label>

// //           <label className="flex items-center gap-2 text-xs">
// //             <input
// //               type="checkbox"
// //               checked={!!formData.removeBadAddress}
// //               onChange={e => setFormData({ ...formData, removeBadAddress: e.target.checked })}
// //             />
// //             Remove bad addresses
// //           </label>
// //         </div>
// //       </div>

// //       {/* ============ SUPPRESSION / SEEDS ============ */}
// //       <div className="border-t pt-4 grid grid-cols-1 md:grid-cols-2 gap-6">
// //         {/* Suppression List selection */}
// //         <div>
// //           <div className="text-xs font-medium text-gray-700 mb-2">Do Not Mail (Suppression) List</div>
// //           <Selectbox
// //             value={formData.dnmMode || ''}
// //             onChange={e =>
// //               setFormData({ ...formData, dnmMode: e.target.value, selectedSuppressionListIds: [] })
// //             }
// //           >
// //             <option value="">None</option>
// //             <option value="existing">Select Existing</option>
// //           </Selectbox>

// //           {loadingLists ? (
// //             <p className="text-xs text-gray-500 mt-2">Loading suppression lists...</p>
// //           ) : formData.dnmMode === 'existing' && (
// //             <div className="mt-3">
// //               <label className="text-xs text-gray-600 block mb-1">Choose Suppression List(s)</label>
// //               <Selectbox
// //                 multiple
// //                 value={formData.selectedSuppressionListIds || []}
// //                 onChange={e => {
// //                   const options = [...e.target.options];
// //                   const selected = options.filter(o => o.selected).map(o => o.value);
// //                   setFormData({ ...formData, selectedSuppressionListIds: selected });
// //                 }}
// //               >
// //                 {suppressionLists.length === 0 ? (
// //                   <option disabled>No suppression lists available</option>
// //                 ) : (
// //                   suppressionLists.map(list => (
// //                     <option key={list._id} value={list._id}>
// //                       {list.suppressionListName || 'Unnamed List'}
// //                       {list.entries && ` (${list.entries.length} addresses)`}
// //                     </option>
// //                   ))
// //                 )}
// //               </Selectbox>
// //               <p className="text-xs text-gray-500 mt-1">Hold Ctrl/Cmd to select multiple list</p>
// //             </div>
// //           )}
// //         </div>

// //         {/* Seed Records selection */}
// //         <div>
// //           <div className="text-xs font-medium text-gray-700 mb-2">Seed Records</div>
// //           <Selectbox
// //             value={formData.seedMode || ''}
// //             onChange={e =>
// //               setFormData({ ...formData, seedMode: e.target.value, selectedSeedListIds: [] })
// //             }
// //           >
// //             <option value="">None</option>
// //             <option value="existing">Select Existing</option>
// //           </Selectbox>

// //           {loadingLists ? (
// //             <p className="text-xs text-gray-500 mt-2">Loading seed lists...</p>
// //           ) : (formData.seedMode === 'existing' || formData.seedMode === 'both') && (
// //             <div className="mt-3">
// //               <label className="text-xs text-gray-600 block mb-1">Choose Seed List(s)</label>
// //               <Selectbox
// //                 multiple
// //                 value={formData.selectedSeedListIds || []}
// //                 onChange={e => {
// //                   const options = [...e.target.options];
// //                   const selected = options.filter(o => o.selected).map(o => o.value);
// //                   setFormData({ ...formData, selectedSeedListIds: selected });
// //                 }}
// //               >
// //                 {seedLists.length === 0 ? (
// //                   <option disabled>No seed lists available</option>
// //                 ) : (
// //                   seedLists.map(list => (
// //                     <option key={list._id} value={list._id}>
// //                       {list.seedListName || 'Unnamed Seed List'}
// //                       {list.seeds && ` (${list.seeds.length} seeds)`}
// //                     </option>
// //                   ))
// //                 )}
// //               </Selectbox>
// //               <p className="text-xs text-gray-500 mt-1">Hold Ctrl/Cmd to select multiple lists</p>
// //             </div>
// //           )}
// //         </div>
// //       </div>

// //       {/* Navigation buttons */}
// //       <div className="flex justify-end mt-3 space-x-2">
// //         <button
// //           onClick={handlePrev}
// //           className="bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600"
// //         >
// //           Prev &lt;
// //         </button>
// //         <button
// //           onClick={handleNext}
// //           className="bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600"
// //         >
// //           Next &gt;
// //         </button>
// //       </div>
// //     </div>
// //   );
// // };

// // export default DataCleanupTab;




import React, { useState, useEffect } from 'react';
import { Button, Input, Selectbox } from '../../css/Shared';
import { useJobContext } from '../../context/JobContext';
import api from '../../components/Api';
import { useAppContext } from '../../context/AppContext';
import Papa from 'papaparse';
import { toast } from 'react-toastify';
import MotionModal from '../../components/MotionModal';
import Donotmail from '../Permits/Donotmail';
import SeedListForm from '../Permits/Seed';



const STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA',
  'HI','ID','IL','IN','IA','KS','KY','LA','ME','MD',
  'MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
  'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC',
  'SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'
];

const DataCleanupTab = ({ goToNextTab, goToPrevTab }) => {
  const { formData, setFormData, finalCSV, setFinalCSV } = useJobContext();
  const { authState } = useAppContext();
  const [activeModal, setActiveModal] = useState(null);
  const [suppressionLists, setSuppressionLists] = useState([]);
  const [seedLists, setSeedLists] = useState([]);
  const [loadingLists, setLoadingLists] = useState(true);


    const openModal = (type, item = null) => {
    setActiveModal(type);
  };

  const closeModal = () => {
    setActiveModal(null);
  };
  // Fetch suppression and seed lists
  useEffect(() => {
    const fetchLists = async () => {
        if (!authState.user?.company?._id) return; // <-- wait for company _id
      try {
        setLoadingLists(true);
        const [suppressRes, seedsRes] = await Promise.all([
          api.post('/permits/suppress/all', { id: authState.user.company._id }),
          api.post('/permits/seeds/all', { id: authState.user.company._id })
        ]);
        setSuppressionLists(suppressRes.data || []);
        setSeedLists(seedsRes.data || []);
      } catch (err) {
        console.error('Failed to load lists:', err);
      } finally {
        setLoadingLists(false);
      }
    };
    fetchLists();
  }, [authState.user]);

  // Helper to toggle restricted states
  const toggleState = (abbr) => {
    const states = formData.restrictStates || [];
    setFormData({
      ...formData,
      restrictStates: states.includes(abbr)
        ? states.filter(s => s !== abbr)
        : [...states, abbr]
    });
  };

  const handlePrev = () => goToPrevTab();

  // Add seeds and suppression to CSV

  const handleNext = async () => {
  try {
   if (
  (formData.selectedSeedListIds?.length) ||
  (formData.selectedSuppressionListIds?.length)
)
{
      const csvText = await finalCSV.text();
const parsed = Papa.parse(csvText.trim(), { header: false });

      const rows = parsed.data;

      if (!rows.length) { goToNextTab(); return; }

      const headers = rows[0];

      if (!headers.includes('seed')) headers.push('seed');
      if (!headers.includes('suppress')) headers.push('suppress');

      const seedIndex = headers.indexOf('seed');
      const suppressIndex = headers.indexOf('suppress');

      // Ensure all existing rows have seed & suppress columns
      for (let i = 1; i < rows.length; i++) {
        rows[i][seedIndex] = rows[i][seedIndex] || '';
        rows[i][suppressIndex] = rows[i][suppressIndex] || '';
      }

      const dataRows = rows.slice(1);  // <--- MOVE this above usage

      // ---------- Seeds ----------
      const seedsToAdd = [];
     [...new Set(formData.selectedSeedListIds || [])].forEach(id => {

        const list = seedLists.find(l => l._id === id);
        list?.seeds?.forEach(seed => {
          // Check if seed already exists in CSV
          const exists = dataRows.some(row => {
            return (
              row[headers.indexOf('firstName')] === (seed.firstName || '') &&
              row[headers.indexOf('lastName')] === (seed.lastName || '') &&
              row[headers.indexOf('address1')] === (seed.address1 || '') &&
              row[headers.indexOf('city')] === (seed.city || '') &&
              row[headers.indexOf('state')] === (seed.state || '') &&
              row[headers.indexOf('zip')] === (seed.zip || '')
            );
          });
          if (exists) return;

          const newRow = new Array(headers.length).fill('');
          const map = {
            prefix: seed.prefix,
            firstName: seed.firstName,
            lastName: seed.lastName,
            middleName: seed.middleName,
            company: seed.company,
            suffix: seed.suffix,
            address1: seed.address1,
            address2: seed.address2,
            address3: seed.address3,
            city: seed.city,
            state: seed.state,
            zip: seed.zip
          };
          Object.keys(map).forEach(key => {
            const idx = headers.indexOf(key);
            if (idx !== -1) newRow[idx] = map[key] || '';
          });
          newRow[seedIndex] = 'Y';
          seedsToAdd.push(newRow);
        });
      });

      // ---------- Suppression ----------
// ---------- Suppression ----------
const suppressionToAdd = [];
[...new Set(formData.selectedSuppressionListIds || [])].forEach(id => {

  const list = suppressionLists.find(l => l._id === id);

  list?.seeds?.forEach(s => {

    // Prevent duplicate suppression records
    const exists = dataRows.some(row => {
      return (
        row[headers.indexOf('firstName')] === (s.firstName || '') &&
        row[headers.indexOf('lastName')] === (s.lastName || '') &&
        row[headers.indexOf('address1')] === (s.address1 || '') &&
        row[headers.indexOf('city')] === (s.city || '') &&
        row[headers.indexOf('state')] === (s.state || '') &&
        row[headers.indexOf('zip')] === (s.zip || '')
      );
    });

    if (exists) return;

    const newRow = new Array(headers.length).fill('');

    const map = {
      prefix: s.prefix,
      firstName: s.firstName,
      lastName: s.lastName,
      middleName: s.middleName,
      company: s.company,
      suffix: s.suffix,
      address1: s.address1,
      address2: s.address2,
      address3: s.address3,
      city: s.city,
      state: s.state,
      zip: s.zip
    };

    Object.keys(map).forEach(key => {
      const idx = headers.indexOf(key);
      if (idx !== -1) newRow[idx] = map[key] || '';
    });

    newRow[suppressIndex] = 'Y';
    suppressionToAdd.push(newRow);
  });
});

      // const suppressionToAdd = [];
      // formData.selectedSuppressionListIds?.forEach(id => {
      //   const list = suppressionLists.find(l => l._id === id);
      //   list?.seeds?.forEach(s => {
      //     const newRow = new Array(headers.length).fill('');
      //     const map = {
      //       prefix: s.prefix,
      //       firstName: s.firstName,
      //       lastName: s.lastName,
      //       middleName: s.middleName,
      //       company: s.company,
      //       suffix: s.suffix,
      //       address1: s.address1,
      //       address2: s.address2,
      //       address3: s.address3,
      //       city: s.city,
      //       state: s.state,
      //       zip: s.zip
      //     };
      //     Object.keys(map).forEach(key => {
      //       const idx = headers.indexOf(key);
      //       if (idx !== -1) newRow[idx] = map[key] || '';
      //     });
      //     newRow[suppressIndex] = 'Y';
      //     suppressionToAdd.push(newRow);
      //   });
      // });

      // Insert seeds & suppression randomly
      seedsToAdd.forEach(row => {
        const randomIndex = Math.floor(Math.random() * (dataRows.length + 1));
        dataRows.splice(randomIndex, 0, row);
      });
      suppressionToAdd.forEach(row => {
        const randomIndex = Math.floor(Math.random() * (dataRows.length + 1));
        dataRows.splice(randomIndex, 0, row);
      });

      // Rebuild CSV
      rows.length = 0;
      rows.push(headers);
      dataRows.forEach(r => rows.push(r));

      const newCSV = Papa.unparse(rows);
      setFinalCSV(new Blob([newCSV], { type: 'text/csv' }));
      toast.success('Seed and suppression addresses added to CSV!');
    }
  } catch (err) {
    console.error('Seed/suppression append failed:', err);
    toast.error('Failed to append seed/suppression lists');
  }

  goToNextTab();
};

//   const handleNext = async () => {
//     try {
//       if (
//         (formData.seedMode === 'existing' && formData.selectedSeedListIds?.length) ||
//         (formData.dnmMode === 'existing' && formData.selectedSuppressionListIds?.length)
//       ) {
//         const csvText = await finalCSV.text();
//         const parsed = Papa.parse(csvText, { header: false });
//         const rows = parsed.data;

//         if (!rows.length) { goToNextTab(); return; }

//         const headers = rows[0];

//         // Add seed & suppress columns if missing
//         if (!headers.includes('seed')) headers.push('seed');
//         if (!headers.includes('suppress')) headers.push('suppress');

//         const seedIndex = headers.indexOf('seed');
//         const suppressIndex = headers.indexOf('suppress');

//         // Ensure all existing rows have seed & suppress columns
//         for (let i = 1; i < rows.length; i++) {
//           rows[i][seedIndex] = rows[i][seedIndex] || '';
//           rows[i][suppressIndex] = rows[i][suppressIndex] || '';
//         }

//         // ---------- Seeds ----------
//        // ---------- Seeds ----------
// const seedsToAdd = [];
// formData.selectedSeedListIds?.forEach(id => {
//   const list = seedLists.find(l => l._id === id);
//   list?.seeds?.forEach(seed => {
//     // Check if seed already exists in CSV
//     const exists = dataRows.some(row => {
//       return (
//         row[headers.indexOf('firstName')] === (seed.firstName || '') &&
//         row[headers.indexOf('lastName')] === (seed.lastName || '') &&
//         row[headers.indexOf('address1')] === (seed.address1 || '') &&
//         row[headers.indexOf('city')] === (seed.city || '') &&
//         row[headers.indexOf('state')] === (seed.state || '') &&
//         row[headers.indexOf('zip')] === (seed.zip || '')
//       );
//     });
//     if (exists) return; // Skip duplicate

//     const newRow = new Array(headers.length).fill('');
//     const map = {
//       prefix: seed.prefix,
//       firstName: seed.firstName,
//       lastName: seed.lastName,
//       middleName: seed.middleName,
//       company: seed.company,
//       suffix: seed.suffix,
//       address1: seed.address1,
//       address2: seed.address2,
//       address3: seed.address3,
//       city: seed.city,
//       state: seed.state,
//       zip: seed.zip
//     };
//     Object.keys(map).forEach(key => {
//       const idx = headers.indexOf(key);
//       if (idx !== -1) newRow[idx] = map[key] || '';
//     });
//     newRow[seedIndex] = 'Y';
//     seedsToAdd.push(newRow);
//   });
// });

//         // Insert seeds & suppression randomly into CSV
//         const dataRows = rows.slice(1);
//         seedsToAdd.forEach(row => {
//           const randomIndex = Math.floor(Math.random() * (dataRows.length + 1));
//           dataRows.splice(randomIndex, 0, row);
//         });
//         suppressionToAdd.forEach(row => {
//           const randomIndex = Math.floor(Math.random() * (dataRows.length + 1));
//           dataRows.splice(randomIndex, 0, row);
//         });

//         // Rebuild CSV
//         rows.length = 0;
//         rows.push(headers);
//         dataRows.forEach(r => rows.push(r));

//         const newCSV = Papa.unparse(rows);
//         setFinalCSV(new Blob([newCSV], { type: 'text/csv' }));
//        toast.success('Seed and suppression addresses added to CSV!');
//       }
//     } catch (err) {
//       console.error('Seed/suppression append failed:', err);
//       toast.error('Failed to append seed/suppression lists');
//     }

//     goToNextTab();
//   };

  return (
    <div className="bg-white border rounded-lg p-6 space-y-6 text-sm">
      <h3 className="text-sm font-semibold text-gray-700">Data (List) Cleanup</h3>

      {/* ================= NCOA / CURRENT RESIDENT ================= */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="text-xs font-medium text-gray-600 mb-1 block">Are we NCOA’ing the List?</label>
          <Selectbox
            value={formData.ncoa === false ? 'no' : 'yes'}
            onChange={e =>
              setFormData({
                ...formData,
                ncoa: e.target.value === 'yes',
                alreadyNcoa: null,
                currentResident: null,
                ncoaDate: ''
              })
            }
          >
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </Selectbox>
        </div>

        {formData.ncoa === false && (
          <div>
            <label className="text-xs font-medium text-gray-600 mb-1 block">Already been NCOA’d?</label>
            <Selectbox
              value={formData.alreadyNcoa === null ? '' : formData.alreadyNcoa ? 'yes' : 'no'}
              onChange={e =>
                setFormData({
                  ...formData,
                  alreadyNcoa: e.target.value === 'yes',
                  currentResident: null,
                  ncoaDate: ''
                })
              }
            >
              <option value="">Select</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </Selectbox>
          </div>
        )}

        {formData.ncoa === false && formData.alreadyNcoa === true && (
          <div>
            <label className="text-xs font-medium text-gray-600 mb-1 block">Date of NCOA</label>
            <Input
              type="date"
              value={formData.ncoaDate || ''}
              onChange={e =>
                setFormData({ ...formData, ncoaDate: e.target.value })
              }
            />
          </div>
        )}

        {formData.ncoa === false && formData.alreadyNcoa === false && (
          <div>
            <label className="text-xs font-medium text-gray-600 mb-1 block">Current Resident Mailing?</label>
            <Selectbox
              value={formData.currentResident === null ? '' : formData.currentResident ? 'yes' : 'no'}
              onChange={e =>
                setFormData({ ...formData, currentResident: e.target.value === 'yes' })
              }
            >
              <option value="">Select</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </Selectbox>
          </div>
        )}
      </div>

      {/* ============ ADDRESS FILTERING ============ */}
      <div className="border-t pt-4 space-y-4">
        <div className="font-medium text-xs text-gray-700">Address Filtering</div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="text-xs text-gray-600 block mb-1">Radius Zipcode</label>
            <Input
              value={formData.radiusZip || ''}
              onChange={e => setFormData({ ...formData, radiusZip: e.target.value })}
            />
          </div>
          <div>
            <label className="text-xs text-gray-600 block mb-1">Radius (Miles)</label>
            <Input
              value={formData.radiusMiles || '0.0'}
              onChange={e => setFormData({ ...formData, radiusMiles: e.target.value })}
            />
          </div>
        </div>

        {/* Restrict States */}
        <details className="mt-4">
          <summary className="cursor-pointer text-xs font-medium text-gray-700">Restrict to States</summary>
          <div className="flex flex-wrap gap-2 mt-3">
            {STATES.map(s => (
              <button
                key={s}
                type="button"
                onClick={() => toggleState(s)}
                className={`px-2 py-1 border rounded text-xs ${
                  (formData.restrictStates || []).includes(s)
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-50'
                }`}
              >
                {s}
              </button>
            ))}
          </div>
        </details>

        {/* Checkboxes */}
        <div className="flex flex-wrap gap-6 items-center text-xs pt-2">
          <label className="flex items-center gap-2 text-xs">
            <input
              type="checkbox"
              checked={!!formData.removeMoved}
              onChange={e => setFormData({ ...formData, removeMoved: e.target.checked })}
            />
            Remove all records that moved
          </label>

          <label className="flex items-center gap-2 text-xs">
            <input
              type="checkbox"
              checked={!!formData.dedup}
              onChange={e => setFormData({ ...formData, dedup: e.target.checked })}
            />
            Remove duplicate records
          </label>

          <label className="flex items-center gap-2 text-xs">
            <input
              type="checkbox"
              checked={!!formData.removeBadAddress}
              onChange={e => setFormData({ ...formData, removeBadAddress: e.target.checked })}
            />
            Remove bad addresses
          </label>
        </div>
      </div>

      {/* ============ SUPPRESSION / SEEDS ============ */}
      <div className="border-t pt-4 grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Suppression List selection */}
        <div>
           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  <div className="text-xs font-medium text-gray-700 mb-2">Do Not Mail (Suppression) List</div>
  <Button onClick={() => openModal('suppress')} className="text-sm  text-blue-600">Add Suppression</Button>
</div>
          <div style={{display:'flex'}}>
          <div className="text-xs font-medium text-gray-700 mb-2"></div>
          <div style={{textAlign:'right',display:'flex',alignItems:'right',justifyItems:'flex-end',position:'relative'}}><button onClick={() => openModal('suppress')}></button></div>
          </div>
          <Selectbox
            value={formData.dnmMode || ''}
            onChange={e =>
              setFormData({ ...formData, dnmMode: e.target.value, selectedSuppressionListIds: [] })
            }
          >
            <option value="">None</option>
            <option value="existing">Select Existing</option>
          </Selectbox>

          {loadingLists ? (
            <p className="text-xs text-gray-500 mt-2">Loading suppression lists...</p>
          ) : formData.dnmMode === 'existing' && (
            <div className="mt-3">
              <label className="text-xs text-gray-600 block mb-1">Choose Suppression List(s)</label>
              <Selectbox
                multiple
                value={formData.selectedSuppressionListIds || []}
                onChange={e => {
                  const options = [...e.target.options];
                  const selected = options.filter(o => o.selected).map(o => o.value);
                  setFormData({ ...formData, selectedSuppressionListIds: selected });
                }}
              >
                {suppressionLists.length === 0 ? (
                  <option disabled>No suppression lists available</option>
                ) : (
                  suppressionLists.map(list => (
                    <option key={list._id} value={list._id}>
                      {list.suppressionListName || 'Unnamed List'}
                      {list.entries && ` (${list.entries.length} addresses)`}
                    </option>
                  ))
                )}
              </Selectbox>
              <p className="text-xs text-gray-500 mt-1">Hold Ctrl/Cmd to select multiple list</p>
            </div>
          )}
        </div>

        {/* Seed Records selection */}
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  <div className="text-xs font-medium text-gray-700 mb-2">Seed Records</div>
  <Button onClick={() => openModal('seed')} className="text-sm  text-blue-600">Add Seed</Button>
</div>
          <Selectbox
            value={formData.seedMode || ''}
            onChange={e =>
              setFormData({ ...formData, seedMode: e.target.value, selectedSeedListIds: [] })
            }
          >
            <option value="">None</option>
            <option value="existing">Select Existing</option>
          </Selectbox>

          {loadingLists ? (
            <p className="text-xs text-gray-500 mt-2">Loading seed lists...</p>
          ) : (formData.seedMode === 'existing' || formData.seedMode === 'both') && (
            <div className="mt-3">
              <label className="text-xs text-gray-600 block mb-1">Choose Seed List(s)</label>
              <Selectbox
                multiple
                value={formData.selectedSeedListIds || []}
                onChange={e => {
                  const options = [...e.target.options];
                  const selected = options.filter(o => o.selected).map(o => o.value);
                  setFormData({ ...formData, selectedSeedListIds: selected });
                }}
              >
                {seedLists.length === 0 ? (
                  <option disabled>No seed lists available</option>
                ) : (
                  seedLists.map(list => (
                    <option key={list._id} value={list._id}>
                      {list.seedListName || 'Unnamed Seed List'}
                      {list.seeds && ` (${list.seeds.length} seeds)`}
                    </option>
                  ))
                )}
              </Selectbox>
              <p className="text-xs text-gray-500 mt-1">Hold Ctrl/Cmd to select multiple lists</p>
            </div>
          )}
        </div>
      </div>

      {/* Navigation buttons */}
      <div className="flex justify-end mt-3 space-x-2">
        <button
          onClick={handlePrev}
          className="bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600"
        >
          Prev &lt;
        </button>
        <button
          onClick={handleNext}
          className="bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600"
        >
          Next &gt;
        </button>
      </div>



  
<MotionModal open={activeModal === 'suppress'} onClose={closeModal}>
  <Donotmail
    onClose={closeModal}
    setSuppressionLists={setSuppressionLists}
    setReset={(newId) => {
      // Automatically select the new suppression list
      setFormData(prev => ({
        ...prev,
        dnmMode: 'existing',
        selectedSuppressionListIds: [newId]
      }));
    }}
  />
</MotionModal>

<MotionModal open={activeModal === 'seed'} onClose={closeModal}>
  <SeedListForm
    onClose={closeModal}
    setSeedLists={setSeedLists}
    setReset={(newId) => {
      // Automatically select the new seed list
      setFormData(prev => ({
        ...prev,
        seedMode: 'existing',
        selectedSeedListIds: [newId]
      }));
    }}
  />
</MotionModal>

    </div>
  );
};

export default DataCleanupTab;






